import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultBaseQuery } from "../../utils/API/fetchBaseQuery";
import { transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";

const reportTypeAPI = createApi({
    baseQuery: defaultBaseQuery,
    reducerPath: 'reportTypeAPI',
    endpoints: (builder) => ({

        addReportType: builder.mutation({
            query: (data) => ({
                url: `/ReportType/AddReportType`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateReportType: builder.mutation({
            query: (data) => ({
                url: `/ReportType/UpdateReportType`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateCalculationOrder: builder.mutation({
            query: (data) => ({
                url: `/ReportTemplates/UpdateCalculationOrder`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getReportTypeList: builder.mutation({
            query: (data) => ({
                url: `/ReportType/GetReportType`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deleteReportType: builder.mutation({
            query: (reportTypeId) => ({
                url: `/ReportType/DeleteReportType?ReportTypeId=${reportTypeId}`,
                method: `DELETE`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllReportTypeList: builder.query({
            query: () => ({
                url: `ReportType/GetAllReportType`,
                method: `GET`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updateReportTypeToggle:builder.mutation({
            query :(data)=>({
                url:`/ReportType/UpdateReportTypeToggle`,
                method:`POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        })
    })
});

export const { 
    useAddReportTypeMutation, 
    useUpdateReportTypeMutation, 
    useUpdateCalculationOrderMutation,
    useGetReportTypeListMutation, 
    useDeleteReportTypeMutation,
    useLazyGetAllReportTypeListQuery,
    useUpdateReportTypeToggleMutation
 } = reportTypeAPI;

export default reportTypeAPI;